export default __webpack_public_path__ + "static/media/refine-done.1a162e8f.webp";